import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useLanguage } from '../../context/LanguageContext';
import { useAnimatedText } from "../../hooks/useAnimatedText";
import { useNavigate } from "react-router-dom";
import "./style.css";

const AnimatedText = ({ text, delay, onComplete }: { text: string; delay: number; onComplete?: () => void }) => {
  const chars = useAnimatedText(text, delay);
  
  
  useEffect(() => {
    if (chars.length === text.length && text.length > 0) {
      if (onComplete) onComplete();
    }
  }, [chars, text, onComplete]);
  
  return (
    <>
      {chars.map((char, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.1 }}
        >
          {char}
        </motion.span>
      ))}
    </>
  );
};

export const About = () => {
  const { t } = useLanguage();
  const [stage, setStage] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="about-page-shell">
              <button
          className="back-button-premium"
          onClick={() => navigate(-1)}
        >
          <img src="arrow1.png" alt="text" className="backhomebutton" />
        </button>
      <div className="about-ambient about-ambient-one"></div>
      <div className="about-ambient about-ambient-two"></div>
      <div className="about-dots"></div>

      <div className="about-layout">
        <div className="container mx-auto max-w-6xl">
          <section className="about-hero-section">
            <div className="about-left-column">
              <div className="about-content">
                <span className="about-mini-label">{t("smart_bag")}</span>
                <h1>{t("about_hero_title_line1")}<br />{t("about_hero_title_line2")}</h1>
                <p className="about-description">
                  <AnimatedText text={t("about_title_text")} delay={0} onComplete={() => setStage(1)} />
                </p>
                {/* ... feature pills ... */}
              </div>

              <section className="about-story-section">
                <div className="about-story-topline">{t("about_story_topline")}</div>
                <h2>{t("about_story_title_line1")}<br />{t("about_story_title_line2")}</h2>
                <p>
                  {stage >= 1 && <AnimatedText text={t("ab_us_1")} delay={0} onComplete={() => setStage(2)} />}
                  <br /><br />
                  {stage >= 2 && <AnimatedText text={t("ab_us_2")} delay={0} onComplete={() => setStage(3)} />}
                  <br /><br />
                  {stage >= 3 && <AnimatedText text={t("ab_us_3")} delay={0} />}
                </p>
              </section>
            </div>
            {/* ... image side ... */}
          </section>

          <div className="stats-grid">
            <div className="stat-card"><h3>10+</h3><p>{t("stat_years")}</p></div>
            <div className="stat-card"><h3>500+</h3><p>{t("stat_clients")}</p></div>
            <div className="stat-card"><h3>99%</h3><p>{t("stat_quality")}</p></div>
            <div className="stat-card"><h3>24/7</h3><p>{t("stat_support")}</p></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
